module.exports = __webpack_public_path__ + "img/logo-jiangjin.e0b8ce92.jpg";